import moment from "moment";

export const getMonthsInYear = (year) => {
  let month = 1;
  let months = [];

  while(month <= 12) {
      let current = moment(`${year}-${month}-01`, "YYYY-MM-DD").format("YYYY-MM-DD");
      months.push(current);
      month++;
  }

  return months;
};

export const getDaysInMonth = (year, month) => {
  let daysInMonth = moment(`${year}-${month}`, "YYYY-MM").daysInMonth();
  let day = 1;
  let days = [];

  while(day <= daysInMonth) {
      let current = moment(`${year}-${month}-${day}`, "YYYY-MM-DD").format("YYYY-MM-DD");
      days.push(current);
      day++;
  }

  return days;
};

export const getHoursInDay = (year, month, day) => {
  let hours = [];
  let hour = 0;

  while(hour < 24) {
      let current = moment(`${year}-${month}-${day} ${hour}:00:00`, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD HH:mm:ss");
      hours.push(current);
      hour++;
  }

  return hours;
};